import { render } from "./BasePagination.vue?vue&type=template&id=1b056c6a&scoped=true"
import script from "./BasePagination.vue?vue&type=script&lang=js"
export * from "./BasePagination.vue?vue&type=script&lang=js"

import "./BasePagination.vue?vue&type=style&index=0&id=1b056c6a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b056c6a"]])

export default __exports__